import serviceRequest from "utils/request";

const baseUrl = "/api/user";

export const newLogin = (param) => {
	const { username, password } = param;
	return serviceRequest({
		url: `${baseUrl}/authenticate`,
		method: "post",
		data: { username, password },
	});
};

export const logout = (param) => {
	return serviceRequest({
		url: `/api/api/logout`,
		method: "post",
		data: param,
	});
};
